"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Timer = (function () {
    function Timer(callback, delay) {
        this.remaining = delay;
        this.start = Date.now();
        this.callback = callback;
        this.id = setTimeout(this.callback, this.remaining);
    }
    Timer.prototype.pause = function () {
        clearTimeout(this.id);
        this.remaining -= Date.now() - this.start;
    };
    Timer.prototype.resume = function () {
        this.start = Date.now();
        this.id = setTimeout(this.callback, this.remaining);
    };
    Timer.prototype.stop = function () {
        clearTimeout(this.id);
    };
    return Timer;
}());
exports.default = Timer;
